import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import Pagination from "../../Services/Pagination";
import moment from "moment";
import { setToastData } from "../../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../../Services/Common";
import useConfirm from "../../Services/Confirmation";

const SurveysList = () => {
	const dispatch = useDispatch();
	const customConfirm = useConfirm();
	const { userData, accessToken } = useSelector((state) => state.user);
	const [showFilter, setShowFilter] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
	const [filter, setFilter] = useState({
		org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
		div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
	});
	const [orgList, setOrgList] = useState([]);
	const [divList, setDivList] = useState([]);
	const [surveyList, setSurveyList] = useState([]);
	const filterHandler = (key, value) => {
		setFilter({ ...filter, [key]: value });
	}
	useEffect(() => {
		dispatch(setPageTitle(`Survey`));
		dispatch(setMainLoading(true));
		let promiseArray = [];
		if (userData.role_slug === "super_admin") {
			promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
		}
		if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
			promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
		}
		if (promiseArray.length > 0) {
			Promise.all(promiseArray)
				.then((response) => {
					if (response[0].config.url === "masters/organization") {
						if (response[0].data.status === "1") {
							setOrgList(response[0].data.data);
						}
					}
					else {
						if (response[0].data.status === "1") {
							setDivList(response[0].data.data);
						}
					}
					if (response?.[1]?.config?.url === "masters/division-list") {
						if (response[1].data.status === "1") {
							setDivList(response[1].data.data);
						}
					}
					runFilter();
				})
				.catch(err => {
					console.log(err);
				})
		}
		else {
			runFilter();
		}
	}, [dispatch, accessToken, userData]);
	const runFilter = (pageNo = 0) => {
		dispatch(setMainLoading(true));
		setSurveyList([]);
		let postData = {
			...filter
		}
		if (pageNo > 0) {
			postData.page = pageNo
			postData.perPage = paginationData.per_page
		}
		PostAxios(`survey/survey-list`, postData, accessToken)
			.then(({ data }) => {
				if (data.status === "1") {
					if (data?.totalRecords) {
						setPaginationData({ total: data?.totalRecords, per_page: data?.perPage });
					}
					setSurveyList(data.list);
				}
			})
			.catch((err) => {
				responseCatchFunc(dispatch, err)
			})
			.finally(() => {
				dispatch(setMainLoading(false));
			})
	}
	const filteredDivList = useMemo(() => {
		let tempL = [];
		let orgId = parseInt(filter.org_id);
		for (let div of divList) {
			if (parseInt(div.org_id) === orgId || orgId === 0) {
				tempL.push(div);
			}
		}
		return tempL;
	}, [filter.org_id, divList]);
	const deleteSurvey = async (surveyId) => {
		let userChoice = await customConfirm({
            description: `Do you want to delete this survey?`,
        });
        if (!userChoice) {
            return;
        }
		dispatch(setMainLoading(true));
		PostAxios(`survey/delete-survey`, { survey_id: surveyId }, accessToken)
			.then(({ data }) => {
				if (data.status === "1") {
					dispatch(setToastData({ message: data.message, isHtml: true, type: 'success', showCloseBtn: true }));
					runFilter();
				}
				else {
					dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
				}
			})
			.catch((err) => {
				responseCatchFunc(dispatch, err)
			})
			.finally(() => {
				dispatch(setMainLoading(false));
			})
	}
	// return (
	// 	<>
	// 		<div className="main-form-sec error-page">
	// 			<div className="page">Coming Soon!</div>
	// 			<Link to={'/'} className="btn btn-blue"><i className="fa-solid fa-chevron-left me-2"></i><span>Back to Dashboard</span></Link>
	// 		</div>
	// 	</>
	// )
	return <>
		<div className="main-form-sec">
			{
				(userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
				<div className="top-right-btn p-0">
					<Link
						to={"/survey/add"}
						className="btn-blue btn br-0"
					>
						Add New Survey
					</Link>
				</div>
			}
			<div className="top-reports-filter">
				<div className={`right-filter-sec`}>
					<button className="filter-toggle" onClick={() => {
						setShowFilter(!showFilter);
					}}>
						<i className="fa-solid fa-filter"></i>
					</button>
					<div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
						{
							userData.role_slug === "super_admin" &&
							<div className="report-filter-field">
								<label className="select-input-outer">Organization</label>
								<div className="static-items-outer">
									<select
										id="org_id"
										name="org_id"
										className="select-input"
										value={filter.org_id}
										onChange={(e) => setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })}
									>
										<option value='0'>All</option>
										{
											orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
										}
									</select>
								</div>
							</div>
						}
						{
							(userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
							<div className="report-filter-field">
								<label className="select-input-outer">Division</label>
								<div className="static-items-outer">
									<select
										id="div_id"
										name="div_id"
										className="select-input"
										value={filter.div_id}
										onChange={(e) => filterHandler("div_id", e.target.value)}
									>
										<option value='0'>All</option>
										{
											filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
										}
									</select>
								</div>
							</div>
						}
						{
							(userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
							<button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); runFilter(1); }}>Submit</button>
						}
					</div>
				</div>
			</div>
			<div className="table-wrapper">
				<table className="table">
					<thead>
						<tr>
							<th>S.No.</th>
							<th>Title</th>
							<th style={{ minWidth: 130 }}>Created on</th>
							<th style={{ minWidth: 110, maxWidth: 200 }}>Mohalla</th>
							<th style={{ minWidth: 110, maxWidth: 200 }}>Submitted</th>
							<th style={{ minWidth: 110 }}>Status</th>
							<th style={{ minWidth: 200 }}>Action</th>
						</tr>
					</thead>
					<tbody>
						{
							surveyList.length > 0 && surveyList.map((item, index) => {
								let divName = '';
								if (parseInt(item.event_user_div) === 0) {
									divName = 'All';
								}
								else if (item.div_name_list.trim() !== "") {
									let splitDNl = item.div_name_list.split(';');
									for (let i of splitDNl) {
										let splitDn = i.split('|');
										if (parseInt(splitDn[0]) === parseInt(userData.user_div)) {
											divName = splitDn[1];
											break;
										}
										else if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
											if (divName !== "") {
												divName += ', ';
											}
											divName += splitDn[1];
										}
									}
								}
								else if (parseInt(item.event_user_div) === parseInt(userData.user_div)) {
									divName = item.division_name;
								}
								return <tr key={`event-item-${index}`}>
									<td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
									<td>{item.title}</td>
									<td>
										<span>{moment(`${item.created_at}`).format('DD MMMM YYYY')} </span>

									</td>
									<td>{divName}</td>
									<td>{item.submitted_at !== "" ? <span className="status-btn approved">Submitted at {moment(`${item.submitted_at}`).format('DD MMM YYYY hh:mm A')}</span> : <span className="status-btn rejected">No</span>}</td>
									<td>
										{
											moment(`${item.valid_until}`).endOf("day") < moment() &&
											<span className="status-btn rejected">Expired</span>
										}
										{
											moment(`${item.valid_until}`).endOf("day") > moment() &&
											<span className="status-btn approved">Active</span>
										}
									</td>
									<td>
										{
											(userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain" || userData.role_slug === "div_admin" || userData.caps_list.includes('survey_responses'))
											&&
											<Link to={'responses'} state={{ survey_id: item.id }} className="btn-blue btn btn-sm ms-2 text-center" title="View Responses"><i className="fa-regular fa-rectangle-list"></i></Link>
											// <button type="button" className="btn-blue btn btn-sm" title="View Responses" onClick={() => {
											// 	navigate('responses', { state: { survey_id: item.id } });
											// }}>
											// 	<i className="fa-regular fa-rectangle-list"></i>
											// </button>
										}
										{
											(userData.role_slug === "super_admin" || userData.role_slug === "org_admin")
											&& moment(`${item.valid_until}`).endOf("day") >= moment() &&
											<Link to={'edit'} state={{ survey_id: item.id }} className="btn-blue btn btn-sm ms-2 text-center" title="Edit Survey"><i className="fa-solid fa-pencil"></i></Link>
											// <button type="button" className="btn-blue btn btn-sm ms-2" onClick={() => {
											// 	navigate('edit',  });
											// }}>

											// </button>
										}
										{
											moment(`${item.valid_until}`).endOf("day") > moment() &&
											<Link to={'fill-survey'} state={{ survey_id: item.id }} className="btn-blue btn btn-sm ms-2 text-center" title="Fill Survey"><i className="fa-solid fa-question-circle"></i></Link>
											// <button type="button" className="btn-blue btn btn-sm ms-2" title="" onClick={() => {
											// 	navigate('', { state: { survey_id: item.id } });
											// }}>

											// </button>
										}
										{
											(userData.role_slug === "super_admin" || userData.role_slug === "org_admin")
											&&
											moment(`${item.valid_from}`).endOf("day") > moment()
											&&
											<button type="button" className="btn-blue btn btn-sm btn-status rejected ms-2" title="Delete Survey" onClick={() => {
												deleteSurvey(item.id);
											}}>
												<i className="fa-solid fa-trash"></i>
											</button>
										}

									</td>
								</tr>
							})
						}
					</tbody>
				</table>
			</div>
			<Pagination
				currentPage={currentPage}
				totalCount={paginationData.total}
				pageSize={paginationData.per_page}
				onPageChange={page => {
					setCurrentPage(page);
					runFilter(page);
				}}
			/>
		</div>
	</>
}
export default SurveysList;